<div class="multi-line-snack-bar" [class]="color">
  @if (data.icon) {
    <mat-icon class="snack-bar-icon">{{ data.icon }}</mat-icon>
  }

  <div class="snack-bar-body">
    <span class="snack-bar-title" [translate]="data.title"></span>
    <p class="snack-bar-message">{{ data.message }}</p>

    @if (data.actionLabel) {
      <div class="snack-bar-actions">
        <button class="action-button" mat-button (click)="action(true)">
          {{ data.actionLabel | translate }}
        </button>
      </div>
    }
  </div>

  <button mat-icon-button class="close-button" (click)="close()" [attr.aria-label]="'CLOSE' | translate">
    <mat-icon>close</mat-icon>
  </button>
</div>
